<!-- =========================================================================================
	File Name: Login.vue
	Description: Login Page
	Item Name: Impulsor Intelectual
	Version: 1.1
	Author: Prasyde S.C
========================================================================================== -->

<template>
	<div class="h-screen flex w-full bg-img">
		<div class="content-init vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
			<form @submit.prevent="login">
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row">
						<div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center text-center">
							<img src="@/assets/images/logo/logo.png" alt="login" class="mx-auto img-login">
						</div>
						<div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center bg-white">
							<div class="p-8">
								<div class="vx-card__title mb-8">
									<h4 class="mb-4 title-login text-center">Iniciar sessión</h4>
									<p class="text-center">Bienvenido al sistema de control</p>
								</div>
								<vs-input id="user" icon="icon icon-user" icon-pack="feather" label-placeholder="Usuario" v-model="user" class="w-full mb-6 no-icon-border"/>
								<vs-input id="pass" type="password" icon="icon icon-lock" icon-pack="feather" label-placeholder="Contraseña" v-model="pass" class="w-full mb-4 no-icon-border" />
								<div class="flex flex-wrap justify-between my-5">
									<!--<vs-checkbox v-model="checkBox1" class="mb-3">Remember Me</vs-checkbox>-->
									<router-link to="/recuperar-contrasena">¿Olvidaste tu contraseña?</router-link>
								</div>
								<!--<vs-button  type="border" to="/pages/register">Register</vs-button>-->
								<vs-divider position="center" class="my-8"></vs-divider>
								<vs-button class="float-right m-bttom20">Entrar</vs-button>

								<!--<div class="social-login mb-4 flex flex-wrap justify-between">
									<span>Or Login With</span>
									<div class="social-login-buttons flex">
										<vs-button color="#1551b1" class="mr-4 px-8" icon="icon icon-facebook" icon-pack="feather"></vs-button>
										<vs-button color="#00aaff" class="px-8" icon="icon icon-twitter" icon-pack="feather"></vs-button>
									</div>
								</div>-->
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
    <vs-popup class="title" title="Usuario y/o contraseña" :active.sync="popupActive">
				<p class="text-content">Incorrectos</p>
				<i class="material-icons" style="font-size: 60px;color: #b53b3b;">highlight_off</i>
    </vs-popup>
	</div>
</template>

<script>
import BASE from '../../../vue.config.js'

const $ = require('jquery')
window.$ = $

export default {
	data() {
		return {
      user: '',
			pass: '',
			colorLoading: '#0d578f',
			popupActive: false
		}
	},
	methods: {
		login(){
			if(this.user == ''){
				document.getElementById('user').style.border = '1px solid #da3d3d';
				setTimeout(() => {
					document.getElementById('user').style.border = '1px solid #b8c2cc';
				}, 6000);
			}
			if(this.pass == ''){
				document.getElementById('pass').style.border = '1px solid #da3d3d';
				setTimeout(() => {
					document.getElementById('pass').style.border = '1px solid #b8c2cc';
				}, 6000);
			}
			if(this.user != '' & this.pass != ''){
				let datos = {
					'Usuario': this.user,
					'Contrasena': this.pass
				}
				fetch(BASE.baseUrl + 'api/login', {
					method: 'POST',
					body: JSON.stringify(datos),
					headers: {
							'plataforma': 1,
							'Content-Type': 'application/json'
					}
				})
				.then(rs => rs.json())
				.catch(error => console.log('error:', error))
				.then(rs => {
					if(rs.status == 200){
						sessionStorage.setItem('token', rs.result.token);
						sessionStorage.setItem('resetPass', rs.result.restablecerContrasena);
						sessionStorage.setItem('jerarquia', rs.result.idJerarquia);
						$('.content-init').css('display', 'none');
						this.openLoadingColor();
						setTimeout(() => this.$router.replace('/'), 2000);
					}else if(rs.status == 204 || rs.status == 429){
						this.popupActive = true
					}
				});
			}
		},
		openLoadingColor() {
      this.$vs.loading({ color: this.colorLoading })
      setTimeout(() => {
        this.$vs.loading.close()
      }, 1900);
    }
	}
}
</script>
<style>
	.title-login{
		text-shadow: 0px 2px 4px rgba(0,0,0,.3);
	}
	.img-login{
		width: 26rem;
		max-width: 100%;
	}
	.m-bttom20{
		margin-bottom: 20px;
	}
	.title{
		text-align: center;
    font-size: 20px;
	}
	.text-content{
		text-align: center;
    font-weight: bold;
    font-size: 20px;
    color: #b53b3b;
	}
</style>
